import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { GoogleMapShell, GTrafficLayer, GPolyline, FitBounds, NumPin, WarnPin } from "@/components/GoogleRouteMap";

export { WARN_COLORS, WARN_LETTER } from "@/components/GoogleRouteMap";

const JAM_COLOR = (seg) => (seg.category === "ROAD_CLOSURE" ? "#7f1d1d" : (seg.magnitude || 0) >= 3 ? "#ef4444" : "#f59e0b");

const Dot = () => (
  <div style={{ background: "#0A84FF", border: "3px solid #fff", borderRadius: "50%", width: 16, height: 16, boxShadow: "0 0 10px rgba(10,132,255,.8)" }} />
);

export const RouteOverviewMap = ({ route, height = 340, incidents = [], jamSegments = [], driverPos = null, showTraffic = false, interactive = false }) => {
  if (!route?.geometry?.length) return null;
  const dp = driverPos ? (Array.isArray(driverPos) ? { lat: driverPos[0], lng: driverPos[1] } : driverPos) : null;
  return (
    <div style={{ height, width: "100%" }}>
      <GoogleMapShell height={height} interactive={interactive} gesture={interactive ? "cooperative" : "none"}>
        {showTraffic && <GTrafficLayer />}
        <FitBounds points={route.geometry} padding={25} />
        <GPolyline path={route.geometry} color="#0A84FF" weight={5} opacity={0.95} />
        {jamSegments.map((seg, i) => (
          <GPolyline key={`jam-${i}`} path={seg.points} color={JAM_COLOR(seg)} weight={6} opacity={0.95} zIndex={3} />
        ))}
        {dp && (
          <AdvancedMarker position={dp}>
            <Dot />
          </AdvancedMarker>
        )}
        {route.yard?.lat != null && (
          <AdvancedMarker position={{ lat: route.yard.lat, lng: route.yard.lon }}>
            <NumPin label="Y" bg="#111" size={24} />
          </AdvancedMarker>
        )}
        {route.stops.map((s) => (
          <AdvancedMarker key={s.store_id} position={{ lat: s.lat, lng: s.lon }} title={`${s.order}. ${s.name}`}>
            <NumPin label={s.order} bg="#FF3B30" size={24} />
          </AdvancedMarker>
        ))}
        {incidents.map((inc, i) => (
          <AdvancedMarker key={`w-${i}`} position={{ lat: inc.lat, lng: inc.lon }} title={inc.description || inc.category}>
            <WarnPin cat={inc.icon_category} size={18} />
          </AdvancedMarker>
        ))}
      </GoogleMapShell>
    </div>
  );
};
